import { keyframes } from 'styled-components';

/* Bouncing entrances */
import bounceIn from 'react-animations/lib/bounce-in';
import bounceInDown from 'react-animations/lib/bounce-in-down';
import bounceInLeft from 'react-animations/lib/bounce-in-left';
import bounceInRight from 'react-animations/lib/bounce-in-right';
import bounceInUp from 'react-animations/lib/bounce-in-up';

/* Bouncing  exits */
import bounceOut from 'react-animations/lib/bounce-out';
import bounceOutDown from 'react-animations/lib/bounce-out-down';
import bounceOutLeft from 'react-animations/lib/bounce-out-left';
import bounceOutRight from 'react-animations/lib/bounce-out-right';
import bounceOutUp from 'react-animations/lib/bounce-out-up';

/* Fading entrances */
import fadeIn from 'react-animations/lib/fade-in';
import fadeInDown from 'react-animations/lib/fade-in-down';
import fadeInDownBig from 'react-animations/lib/fade-in-down-big';
import fadeInLeft from 'react-animations/lib/fade-in-left';
import fadeInLeftBig from 'react-animations/lib/fade-in-left-big';
import fadeInRight from 'react-animations/lib/fade-in-right';
import fadeInRightBig from 'react-animations/lib/fade-in-right-big';
import fadeInUp from 'react-animations/lib/fade-in-up';
import fadeInUpBig from 'react-animations/lib/fade-in-up-big';

/* Fading exits */
import fadeOut from 'react-animations/lib/fade-out';
import fadeOutDown from 'react-animations/lib/fade-out-down';
import fadeOutDownBig from 'react-animations/lib/fade-out-down-big';
import fadeOutLeft from 'react-animations/lib/fade-out-left';
import fadeOutLeftBig from 'react-animations/lib/fade-out-left-big';
import fadeOutRight from 'react-animations/lib/fade-out-right';
import fadeOutRightBig from 'react-animations/lib/fade-out-right-big';
import fadeOutUp from 'react-animations/lib/fade-out-up';
import fadeOutUpBig from 'react-animations/lib/fade-out-up-big';

/* Flippers */
import flipInX from 'react-animations/lib/flip-in-x';
import flipInY from 'react-animations/lib/flip-in-y';
import flipOutX from 'react-animations/lib/flip-out-x';
import flipOutY from 'react-animations/lib/flip-out-y';

/* Lightspeed */
import lightSpeedIn from 'react-animations/lib/light-speed-in';
import lightSpeedOut from 'react-animations/lib/light-speed-out';

/* Rotating entrances */
import rotateIn from 'react-animations/lib/rotate-in';
import rotateInDownLeft from 'react-animations/lib/rotate-in-down-left';
import rotateInDownRight from 'react-animations/lib/rotate-in-down-right';
import rotateInUpLeft from 'react-animations/lib/rotate-in-up-left';
import rotateInUpRight from 'react-animations/lib/rotate-in-up-right';

/* Rotation exits */
import rotateOut from 'react-animations/lib/rotate-out';
import rotateOutDownLeft from 'react-animations/lib/rotate-out-down-left';
import rotateOutDownRight from 'react-animations/lib/rotate-out-down-right';
import rotateOutUpLeft from 'react-animations/lib/rotate-out-up-left';
import rotateOutUpRight from 'react-animations/lib/rotate-out-up-right';

/* Sliding entrances */
import slideInDown from 'react-animations/lib/slide-in-down';
import slideInLeft from 'react-animations/lib/slide-in-left';
import slideInRight from 'react-animations/lib/slide-in-right';
import slideInUp from 'react-animations/lib/slide-in-up';

/* Sliding exits */
import slideOutDown from 'react-animations/lib/slide-out-down';
import slideOutLeft from 'react-animations/lib/slide-out-left';
import slideOutRight from 'react-animations/lib/slide-out-right';
import slideOutUp from 'react-animations/lib/slide-out-up';

/* Zooming entrances */
import zoomIn from 'react-animations/lib/zoom-in';
import zoomInDown from 'react-animations/lib/zoom-in-down';
import zoomInLeft from 'react-animations/lib/zoom-in-left';
import zoomInRight from 'react-animations/lib/zoom-in-right';
import zoomInUp from 'react-animations/lib/zoom-in-up';

/* Zooming exits */
import zoomOut from 'react-animations/lib/zoom-out';
import zoomOutDown from 'react-animations/lib/zoom-out-down';
import zoomOutLeft from 'react-animations/lib/zoom-out-left';
import zoomOutRight from 'react-animations/lib/zoom-out-right';
import zoomOutUp from 'react-animations/lib/zoom-out-up';

export const getInAnimationIn = (animation) => {
  switch (animation) {
    case 'bounce':
      return keyframes`${bounceIn}`;
    case 'bounceDown':
      return keyframes`${bounceInDown}`;
    case 'bounceLeft':
      return keyframes`${bounceInLeft}`;
    case 'bounceRight':
      return keyframes`${bounceInRight}`;
    case 'bounceUp':
      return keyframes`${bounceInUp}`;

    case 'fade':
      return keyframes`${fadeIn}`;
    case 'fadeDown':
      return keyframes`${fadeInDown}`;
    case 'fadeDownBig':
      return keyframes`${fadeInDownBig}`;
    case 'fadeLeft':
      return keyframes`${fadeInLeft}`;
    case 'fadeLeftBig':
      return keyframes`${fadeInLeftBig}`;
    case 'fadeRight':
      return keyframes`${fadeInRight}`;
    case 'fadeRightBig':
      return keyframes`${fadeInRightBig}`;
    case 'fadeUp':
      return keyframes`${fadeInUp}`;
    case 'fadeUpBig':
      return keyframes`${fadeInUpBig}`;

    case 'flipX':
      return keyframes`${flipInX}`;
    case 'flipY':
      return keyframes`${flipInY}`;

    case 'lightSpeed':
      return keyframes`${lightSpeedIn}`;

    case 'rotate':
      return keyframes`${rotateIn}`;
    case 'rotateDownLeft':
      return keyframes`${rotateInDownLeft}`;
    case 'rotateDownRight':
      return keyframes`${rotateInDownRight}`;
    case 'rotateUpLeft':
      return keyframes`${rotateInUpLeft}`;
    case 'rotateUpRight':
      return keyframes`${rotateInUpRight}`;

    case 'slideDown':
      return keyframes`${slideInDown}`;
    case 'slideLeft':
      return keyframes`${slideInLeft}`;
    case 'slideRight':
      return keyframes`${slideInRight}`;
    case 'slideUp':
      return keyframes`${slideInUp}`;

    case 'zoom':
      return keyframes`${zoomIn}`;
    case 'zoomDown':
      return keyframes`${zoomInDown}`;
    case 'zoomLeft':
      return keyframes`${zoomInLeft}`;
    case 'zoomRight':
      return keyframes`${zoomInRight}`;
    case 'zoomUp':
      return keyframes`${zoomInUp}`;

    default:
      return keyframes`${fadeIn}`;
  }
};

export const getInAnimationOut = (animation) => {
  switch (animation) {
    case 'bounce':
      return keyframes`${bounceOut}`;
    case 'bounceDown':
      return keyframes`${bounceOutDown}`;
    case 'bounceLeft':
      return keyframes`${bounceOutLeft}`;
    case 'bounceRight':
      return keyframes`${bounceOutRight}`;
    case 'bounceUp':
      return keyframes`${bounceOutUp}`;

    case 'fade':
      return keyframes`${fadeOut}`;
    case 'fadeDown':
      return keyframes`${fadeOutDown}`;
    case 'fadeDownBig':
      return keyframes`${fadeOutDownBig}`;
    case 'fadeLeft':
      return keyframes`${fadeOutLeft}`;
    case 'fadeLeftBig':
      return keyframes`${fadeOutLeftBig}`;
    case 'fadeRight':
      return keyframes`${fadeOutRight}`;
    case 'fadeRightBig':
      return keyframes`${fadeOutRightBig}`;
    case 'fadeUp':
      return keyframes`${fadeOutUp}`;
    case 'fadeUpBig':
      return keyframes`${fadeOutUpBig}`;

    case 'flipX':
      return keyframes`${flipOutX}`;
    case 'flipY':
      return keyframes`${flipOutY}`;

    case 'lightSpeed':
      return keyframes`${lightSpeedOut}`;

    case 'rotate':
      return keyframes`${rotateOut}`;
    case 'rotateDownLeft':
      return keyframes`${rotateOutDownLeft}`;
    case 'rotateDownRight':
      return keyframes`${rotateOutDownRight}`;
    case 'rotateUpLeft':
      return keyframes`${rotateOutUpLeft}`;
    case 'rotateUpRight':
      return keyframes`${rotateOutUpRight}`;

    case 'slideDown':
      return keyframes`${slideOutDown}`;
    case 'slideLeft':
      return keyframes`${slideOutLeft}`;
    case 'slideRight':
      return keyframes`${slideOutRight}`;
    case 'slideUp':
      return keyframes`${slideOutUp}`;

    case 'zoom':
      return keyframes`${zoomOut}`;
    case 'zoomDown':
      return keyframes`${zoomOutDown}`;
    case 'zoomLeft':
      return keyframes`${zoomOutLeft}`;
    case 'zoomRight':
      return keyframes`${zoomOutRight}`;
    case 'zoomUp':
      return keyframes`${zoomOutUp}`;

    default:
      return keyframes`${fadeOut}`;
  }
};
